<section [ngClass]="dynamicClass">
  <app-hero-internal *ngIf="LoanData?.Image?.value?.src" [data]="LoanData"></app-hero-internal>
  <app-breadcrumb *ngIf="breadcrumbData" [data]="breadcrumbData"></app-breadcrumb>
  <!-- Highlights START-->
  <section *ngIf="highlight == true " class="pb-container pb-highlights">
    <div class="pb-flex pb-flex-col lg:pb-flex-row pb-pl-0 lg:pb-pl-7 pb-h-full"
      style="background-color: rgba(var(--pb-m-hightlight-background),1); min-height: 100px;">
      <div
        class="pb-flex pb-flex-col pb-justify-evenly lg:pb-flex-row pb-gap-0 lg:pb-gap-7 xl:pb-gap-11 pb-items-start pb-w-full">
        <!-- Funding Amount -->
        <div *ngIf="LoanData?.FundingAmountLabel.value"
          class="pb-c-highlight-item pb-text-left last:pb-border-b-0 pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.FundingAmountLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold" *scText="LoanData?.FundingAmountValue"></h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.FundingAmountNote"></p>
          </div>
        </div>
        <!-- Subscription -->
        <!-- <div *ngIf="LoanData?.SubscriptionValue.value"
          class="pb-c-highlight-item pb-text-left last:pb-border-b-0 pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.SubscriptionLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold" *scText="LoanData?.SubscriptionValue"></h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.SubscriptionNote"></p>
          </div>
        </div> -->
        <!-- Duration -->
        <div *ngIf="LoanData?.DurationValue?.value"
          class="pb-text-left last:pb-border-b-0 pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.DurationLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
              {{LoanData?.DurationValue?.value}}
            </h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.DurationNote"></p>
          </div>
        </div>
        <!-- Rate -->
        <div *ngIf="LoanData?.Rate?.value"
          class="pb-text-left last:pb-border-b-0 pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.RateLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
              {{LoanData?.Rate?.value}}
            </h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.RateNote"></p>
          </div>
        </div>
        <!-- RateType -->
        <div *ngIf="LoanData?.RateTypeValue?.value"
          class="pb-text-left last:pb-border-b-0 pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.RateTypeLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
              {{LoanData?.RateTypeValue?.value}}
            </h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.RateTypeNote"></p>
          </div>
        </div>
        <!-- LoanCost -->
        <div *ngIf="LoanData?.LoanCostValue?.value"
          class="pb-text-left last:pb-border-b-0 pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.LoanCostLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto ">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
              {{LoanData?.LoanCostValue?.value}}
            </h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.LoanCostNote"></p>
          </div>
        </div>
        <!-- AdditionalFeature -->
        <div *ngIf="LoanData?.AdditionalFeatureValue?.value"
          class="pb-text-left last:pb-border-b-0 pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.AdditionalFeatureLabel">
          </h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
              {{LoanData?.AdditionalFeatureValue?.value}}
            </h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.AdditionalFeatureNote"></p>
          </div>
        </div>
        <!-- Currency -->
        <div *ngIf="LoanData?.CurrencyValue?.value"
          class="pb-text-left last:pb-border-b-0 pb-c-highlight-item pb-py-4 pb-px-3 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-xs lg:pb-mb-1 pb-mb-0" *scText="LoanData?.CurrencyLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
              {{LoanData?.CurrencyValue?.value}}
            </h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.CurrencyNote"></p>
          </div>
        </div>
        <!-- ProcessingFeeApplication -->
        <div *ngIf="LoanData?.ProcessingFeeApplicationValue?.value"
          class="pb-c-highlight-item pb-py-4 pb-pl-10 pb-pr-4 pb-flex pb-flex-row pb-justify-center pb-border-b pb-items-center pb-w-full pb-gap-11 lg:pb-px-0 lg:pb-py-5 lg:pb-flex-col lg:pb-items-start lg:pb-w-auto lg:pb-gap-0 lg:pb-border-b-0">
          <h2 class="pb-w-1/2 lg:pb-w-auto pb-text-left last:pb-border-b-0 pb-text-xs lg:pb-mb-1 pb-mb-0"
            *scText="LoanData?.ProcessingFeeApplicationLabel"></h2>
          <div class="pb-w-1/2 lg:pb-w-auto">
            <h3 class="pb-text-h-xs lg:pb-text-h-md pb-font-bold">
              {{LoanData?.ProcessingFeeApplicationValue?.value}}
            </h3>
            <p class="pb-text-xs pb-font-bold" *scText="LoanData?.ProcessingFeeApplicationNote"></p>
          </div>
        </div>
      </div>
      <div class="pb-block lg:pb-hidden pb-border-b pb-c-highlight-item"></div>
      <div *ngIf="LoanData?.HighlightButton?.value?.href"
        class="pb-pt-6 lg:pb-pt-0 pb-pb-6 lg:pb-pb-0 lg:pb-w-auto pb-w-11/12 lg:pb-block pb-self-center lg:pb-self-auto pb-items-center">
        <a *ngIf="LoanData?.OnlineIssueing" href="{{LoanData?.HighlightButton?.value?.href}}" aria-label="#"
          class="pb-h-full pb-px-5 pb-py-4 pb-space-y-1 pb-bg-link  pb-self-center pb-items-center pb-flex pb-justify-between lg:pb-items-start lg:pb-flex-col">
          <h3 class="pb-hidden lg:pb-block pb-text-xs">{{LoanData?.HighlightButton?.value?.title}}</h3>
          <h2 class="pb-text-h-sm pb-font-bold">{{LoanData?.HighlightButton?.value?.text}}</h2>
          <i class="pb-icon pb-icon-arrow-right lg:pb-text-i-32 pb-text-i-24"></i>
        </a>
      </div>
    </div>

  </section>
  <!-- Highlights END -->

  <!-- Banner-Image-List START -->
  <section *ngIf="rendering?.fields?.Calculator?.length > 0"
    class="pb-container">
    <div class="pb-flex pb-flex-col pb-gap-5 lg:pb-gap-6 lg:pb-flex-row-reverse">
      <!-- <div *ngIf="rendering?.fields?.Calculator?.length <= 0 && LoanData?.FaceCardImage?.value?.src"
        class="lg:pb-w-1/2">
        <img *ngIf="!isMobile && !energySave" src="{{LoanData?.FaceCardImage?.value?.src}}"
          alt="{{LoanData?.FaceCardImage?.value?.alt}}" class="pb-aspect-[4/3] pb-object-cover" />
        <img *ngIf="isMobile && !energySave" src="{{LoanData?.FaceCardImage?.value?.src}}"
          alt="{{LoanData?.FaceCardImage?.value?.alt}}" class="pb-h-full pb-object-cover" />
        <img *ngIf="!isMobile && energySave" src="{{LoanData?.FaceCardImageGreen ?.value?.src}}"
          alt="{{LoanData?.FaceCardImageGreen ?.value?.alt}}" class="pb-aspect-[4/3] pb-object-cover" />
        <img *ngIf="isMobile && energySave" src="{{LoanData?.FaceCardImageGreen ?.value?.src}}"
          alt="{{LoanData?.FaceCardImageGreen ?.value?.alt}}" class="pb-h-full pb-object-cover" />
      </div> -->
      <div *ngIf="rendering?.fields?.Calculator?.length > 0" class="lg:pb-w-1/2">
        <app-calculator-loan-mini [rendering]="rendering?.fields?.Calculator[0]"></app-calculator-loan-mini>
      </div>
      <div class="pb-flex pb-flex-col lg:pb-gap-8 pb-w-full lg:pb-w-1/2">
        <h2 *ngIf="LoanData?.DescriptionTitle" class="pb-text-d-md-m lg:pb-text-d-md pb-font-serif">
          {{LoanData?.DescriptionTitle?.value}}
        </h2>
        <div class="pb-text-md-m lg:pb-text-lg" [innerHTML]="LoanData?.ShortDescription?.value">
          <!-- {{LoanData?.ShortDescription?.value}} -->
        </div>
        <div class="pb-flex pb-flex-col pb-gap-5 pb-icon-list pb-mt-7 lg:pb-mt-0"
          [innerHTML]="LoanData?.KeyFeatures.value"></div>
        <ng-container *ngIf="LoanData?.AnchorTo?.value && LoanData?.AnchorId?.value">
          <button [pageScrollOffset]="120" [pageScrollDuration]="1000"
            (click)="scrollToAnchor(LoanData?.AnchorId?.value)"
            class="pb-flex items-center pb-w-fit pb-mt-5 lg:pb-mt-0 pb-cursor-pointer">
            <span class="pb-underline pb-text-md-m lg:pb-text-md pb-text-color-brand pb-font-bold">
              {{LoanData?.AnchorTo?.value}}
            </span>
          </button>
        </ng-container>
      </div>
    </div>
  </section>
  <!-- Banner-Image-List END -->
  <!-- text-block -->
  <section *ngIf="rendering?.fields?.Calculator?.length <= 0" class="pb-container">
    <div class="pb-flex pb-flex-col lg:pb-flex-row pb-gap-6">
      <div class="lg:pb-w-7/12">
        <div class="pb-text-md-m lg:pb-text-lg lg:pb-w-5/6" [innerHTML]="LoanData?.ShortDescription?.value"></div>
        <!-- <div *ngIf="LoanData?.Link?.value?.href || LoanData?.SecondaryLink?.value?.href" class="pb-flex pb-flex-col">
          <a *ngIf="LoanData?.Link?.value?.href" hybridHref href="{{LoanData?.Link?.value?.href}}"
            target="{{LoanData?.Link?.value?.target}}" class="pb-mt-4 md:pb-w-fit">{{LoanData?.Link?.value?.text}}
          </a>
          <a *ngIf="LoanData?.SecondaryLink?.value?.href" hybridHref href="{{LoanData?.SecondaryLink?.value?.href}}"
            target="{{LoanData?.SecondaryLink?.value?.target}}"
            class="pb-mt-4 md:pb-w-fit">{{LoanData?.SecondaryLink?.value?.text}}
          </a>
        </div> -->
      </div>
      <div class="pb-flex pb-flex-col pb-gap-4 lg:pb-gap-5 pb-w-full lg:pb-w-5/12 pb-icon-list"
        *scRichText="LoanData?.KeyFeatures">
      </div>
    </div>
    <a *ngIf="LoanData?.AnchorId?.value" pageScroll [pageScrollOffset]="120" [pageScrollDuration]="1000"
      href="#{{LoanData?.AnchorId?.value}}" attr.aria-label="{{LoanData?.AnchorId?.value}}"
      class="items-center pb-flex pb-w-fit pb-mt-5 lg:pb-mt-0 pb-cursor-pointer">
      <span
        class="pb-link pb-font-bold">{{LoanData?.AnchorTo?.value}}</span>
    </a>
    <a *ngIf="rendering.fields?.ModalText?.value && hasModal" href="#ContactForm" aria-label="Open contact form"
      (click)="openModal($event)"
      class="pb-link pb-font-bold">{{rendering.fields?.ModalText?.value}}</a>
  </section>
</section>